import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Benefits } from './components/Benefits';
import { Includes } from './components/Includes';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="2rkx2pb6487kw">
      <Hero data-id="element-1" data-mp="2rl6vt7mgiuut" />
      <main data-id="element-2" data-mp="2risyes4b16k3">
        <PainPoints data-id="element-3" data-mp="2mlua4q7bnttt" />
        <Benefits data-id="element-4" data-mp="2mmcbu2cr7094" />
        <Includes data-id="element-5" data-mp="2mmvkesgikcah" />
        <Pricing data-id="element-6" data-mp="2mndmw6trrmqu" />
        <Guarantee data-id="element-7" data-mp="2mjpy1kz9roig" />
      </main>
      <Footer data-id="element-8" data-mp="31b8ka0iq2fa9" />
    </div>;
}